import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl } from '@angular/forms';

@Injectable()
export class ToolboxService {
    /**
     * Insère un élément dans une liste à un index données, avec possibilité d'écraser l'élément présent à l'index indiqué.
     * @param array Liste cible
     * @param element Elément à insérer
     * @param index Index d'insertion
     * @param replace Remplace ou non l'élément array[index]
     */
    public arrayInsert<T>(array: T[], element: T, index: number = 0, replace: boolean = false): T[] {
        let res: T[];

        if (!array || !array.length) {
            res = [element];
        } else if (index < 0) {
            res = [element, ...array];
        } else if (index >= array.length) {
            res = [...array, element];
        } else {
            res = [...array.slice(0, index), element, ...array.slice(index + (replace ? 1 : 0))];
        }

        return res;
    }

    /**
     * Supprime un élément d'une liste données, en recherchant l'élément ou à partir de son index.
     * @param array Liste cible
     * @param element Elément à supprimer
     * @param index Index de l'élément
     */
    public arrayRemove<T>(array: T[], element: T, index: number = -1): T[] {
        let res = [...array];

        if (array && array.length) {
            if (index > -1) {
                res = [...array.slice(0, index), ...array.slice(index + 1)];
            } else {
                for (let i = 0; i < array.length; i++) {
                    if (array[i] === element) {
                        res = [...array.slice(0, i), ...array.slice(i + 1)];
                        break;
                    }
                }
            }
        }

        return res;
    }

    /**
     * Détermine si une chaîne de caractères est null, vide ou se compose uniquement d'espaces blancs.
     * @param str La chaîne de caractères à tester
     */
    public stringIsNullOrWhiteSpace(str: string) {
        return !str || str.match(/^ *$/) !== null || str === '';
    }

    public telValidator(): ValidatorFn {
        return (control: AbstractControl) => {
            if (this.stringIsNullOrWhiteSpace(control.value.toString())) {
                return null;
            }
            const value = control.value.replace(/\s/g, '');

            const regexp = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/;
            const match = regexp.test(value);

            const telLenghtValid = (value.toString().length < 16 && value.toString().length > 7);
            return telLenghtValid && match ? null : { telUnvalid: true };
        };
    }

    public indicatifValidator(): ValidatorFn {
        return (control: AbstractControl) => {
            if (this.stringIsNullOrWhiteSpace(control.value.toString())) {
                return null;
            }
            const regexp = new RegExp(/^\d{1,5}$/g);
            return regexp.test(control.value) ? null : { indicatifUnvalid: true };
        };
    }
}
